if ($('#app-ratings-tv-market-comp').length) {
    var book;
    var distributors;
    var day_part;

    var table_data;
    var p_base;
    var m_base;
    var f_base;

    var form_markets;
    var form_playbacks;
    var form_books;
    var form_dists;

    var form_curr_market;
    var form_curr_playback;
    var form_curr_book;
    var form_curr_dists;

    var dt;

    var playback_types = {
        'LPM': {
            'LO': 'Live Only',
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'SRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'CRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'DIA': {
            'L1': 'Live Plus 1'
        }
    };

    var playback_types_all = {
        'LO': 'Live Only',
        'LS': 'Live Plus Same Day',
        'L3': 'Live Plus 3',
        'L7': 'Live Plus 7',
        'L1': 'Live Plus 1'
    };
    var chart_stations=[];
    $('#custom_chart').on('click', function () {
        var html_type= ' <option value=""></option>' +
            '                                            <option value="pie">Pie</option>' +
            '                                            <option value="column">Column (Vertical)</option>' +
            '                                            <option value="bar">Column (Horizontal)</option>';

        $('#chart_type').select2({
            minimumResultsForSearch: 5,
            placeholder: 'Select one....',
        });
        $('#chart_type').html(html_type);
        $('#chart_data_type').select2({
            minimumResultsForSearch: 5
        });
        $('#chart_demo_options').select2({
            placeholder: "Select at least one..",
            closeOnSelect: false,
            placeholder: 'Select at least one....',
        });

        var table=   $('#ratings_market_comp_table ').DataTable();
        console.log('table',table);
        var ages=[];
        table.rows().eq(0).each( function ( index ) {
            var row = table.row( index );

            var data = row.data();
            console.log('row.data', data)
            for(var i in data) {
                console.log('i', i);
                if(i !== 'base' && i!=='gender' && i !== 'station' && ages.indexOf(i) === -1)
                   ages.push(i);
            }
        } );
        $('#chart_age').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });
        var html = '';
        for(var i in ages)
            html +='<option value="'+ages[i]+'">'+ages[i]+'</option>';
        $('#chart_age').html(html).multiSelect('refresh');
        $('#chart_stations').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_sta'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_sta'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });

        var html = '';
        for(var i in chart_stations) {
            var string= chart_stations[i].split('(');
            html += '<option value="' + string[0].trim() + '">' + chart_stations[i] + '</option>';
        }
        $('#chart_stations').html(html).multiSelect('refresh');

        $('#sel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('select_all');
        });
        $('#desel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('deselect_all');
        });
        $('#sel_all_chart_sta').on('click', function (e) {
            $('#chart_stations').multiSelect('select_all');
        });
        $('#desel_all_chart_sta').on('click', function (e) {
            $('#chart_stations').multiSelect('deselect_all');
        });

        $('#graphsOptionsModal').modal('show');
    });
    $('#submit_charts_options').on('click', function(){
        if($('#chart_type option:selected').val() == ''){
            swal({
                    title: "Warning",
                    text: "Select Chart Type first...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_demo_options').val().length == 0){
            swal({
                    title: "Warning",
                    text: "Select at least one Demo...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_age').val().length == 0){
            swal({
                    title: "Warning",
                    text: 'Select at least one Age Range..',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_stations').val().length == 0){
            swal({
                    title: "Warning",
                    text: 'Select at least one Station..',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else {
            show_overlay_loader('#graphsOptionsModal .modal-content');
            var age_charts = $('#chart_age').val();
            var st_charts =  $('#chart_stations').val();
            var data_type = 'Impressions';
            var demo_type = $('#chart_demo_options').val();

            console.log('vendor_charts', age_charts);
            console.log('demo_type', demo_type);
            var results=[];
            var results_base=[];
            for(var y in st_charts) {
                results[st_charts[y]] = [];
                results_base[st_charts[y]] = [];

            }

            console.log('results', results);
            var thousands_total = 0;

            var table= $('#ratings_market_comp_table ').DataTable();
            var st='';
            table.rows().eq(0).each( function ( index ) {
                var row = table.row( index );
                var data = row.data();
                if(data.gender == 'P')
                    st= data.station;
                if(data['gender'] == demo_type && st_charts.indexOf(st) !== -1){
                    for(var i in age_charts){
                        results[st][age_charts[i]] = (data[age_charts[i]].impressions == '')? 0 : parseFloat(data[age_charts[i]].impressions);
                        thousands_total += (data[age_charts[i]].impressions == '')? 0 : parseFloat(data[age_charts[i]].impressions);
                        results_base[st][age_charts[i]] = (data.base == '')? 0 : parseFloat(data.base);
                    }
                }
            });
            var format= '';
            console.log('results', results);
            console.log('results_base', results_base);

            if ($('#chart_type option:selected').val() == 'column' || $('#chart_type option:selected').val() == 'bar') {
                var series=[];
                for(var demo in results){
                    var data=[];
                    for(var age in results[demo]){
                       var perc= parseFloat( Number(Math.round(((Math.round(parseFloat(results[demo][age])/1000) / Math.ceil(parseFloat(results_base[demo][age])/1000)) * 100) +'e1')+'e-1'));
                       if($('#chart_data_type option:selected').val() == 'both') {
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(parseFloat(results[demo][age]) / 1000),
                                percentage: parseFloat(perc),
                                drilldown: null,
                            });
                        }
                        else if($('#chart_data_type option:selected').val() == 'impressions'){
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(parseFloat(results[demo][age]) / 1000),
                               // percentage: parseFloat(perc),
                                drilldown: null,
                            });
                        }
                        else{
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(perc),
                                drilldown: null,
                            });
                        }
                    }
                    series.push({
                        name: demo,
                        data: data,
                    });
                }
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.percentage:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.y:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#book').html(),
                    },
                    subtitle:{
                        text:  $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ' )',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0,
                          //  stacking: 'percent'
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:5px"><b>'+ format +'</td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true,
                    },
                    series: series,
                });
            }
            else{
                var series = [];
                var data2 = [];

                for(var demo in results){
                    var total = 0;
                    var arr= [];
                    var cont=0;
                    var total_age= 0;
                    for(var age in results[demo]){
                        total += parseFloat(results[demo][age]);
                        total_age = parseFloat(results[demo][age]);
                        var perc= parseFloat( Number(Math.round(((Math.round(parseFloat(results[demo][age])/1000) / Math.ceil(parseFloat(results_base[demo][age])/1000)) * 100) +'e1')+'e-1'));
                        arr.push({name: age, y: parseFloat(total_age)/1000, x: perc, drilldown: null});
                        cont++;
                    }
                    data2.push({
                        name: demo,
                        id: demo,
                        data: arr,
                    });
                    var percent = 0;
                    percent= (thousands_total > 0) ? parseFloat(((parseFloat(total ) * 100) / thousands_total)).toFixed(2) : 0;
                    series.push({
                        name: demo,
                        y: total / 1000,
                        x: percent,
                        drilldown: demo,
                    });
                }
                console.log('data2', data2);
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.x:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.x:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';

                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type_name = "Thousands";
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type_name = "Percent"
                else
                    dt_type_name = 'Thousands & Percent';
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#book').html(),
                    },
                    subtitle:{
                        text:    $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ')<br> <span style="color: red"> Click the slices to view  '+ dt_type +' by Age Range. </span>',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true,
                                // format: '${point.y:.2f}'
                            },
                            showInLegend: true,
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">'+ dt_type_name +': </td>' +
                            '<td style="padding:5px"><b>'+ format +' </b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: [
                        {
                            name: 'Station',
                            colorByPoint: true,
                            data: series
                        }
                    ],
                    drilldown: {
                        series: data2
                    }
                });
            }

            $('#GraphsModal').modal('show');
            hide_overlay_loader('#graphsOptionsModal .modal-content');
        }
    });

    $(document).ready(function(){
        show_loader();
        dayPartInputInit('16:00', '23:00', 'tv');
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/markets',
            dataType: 'json',
            success: function (data) {
                var input = $('#form_market');
                data = collect(data).sortBy('name').all();

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + index + '">' + value['name'] + '</option>')
                });

                form_markets = data;

                input.select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    ratingsCompOnMarketChange(this);
                });

                $('#form_playback_type').select2({
                    placeholder: "Select a market...",
                    minimumResultsForSearch: 10
                });

                $('#form_book').select2({
                    placeholder: "Select a data stream...",
                    minimumResultsForSearch: 10
                });

                $('#form_dists').multiSelect(searchableMultiSelectDef);

                $('#form_reset').bind('click', function(){
                    ratingsCompMarketReset();
                });

                $('#form_submit').bind('click', function(){
                    chart_stations = []
                    $('#form_dists option:selected').each(function () {
                        chart_stations[$(this).val()] = $(this).html();
                    });

                    ratingsCompMarketSubmit();
                });

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    });

    var ratingsCompMarketReset = function(step){
        if(typeof step === 'undefined'){
            step = 'all';
        }

        if(step === 'all') {
            var input = $('#form_market');

            input.data('select2').destroy();
            input.unbind('select2:select');

            input.html('').append('<option value=""></option>');
            $.each(form_markets, function (index, value) {
                input.append('<option value="' + index + '">' + value['name'] + '</option>')
            });

            input.attr('disabled', null);
            input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            });
            input.unbind('select2:select').on('select2:select', function (evt) {
                ratingsCompOnMarketChange(this);
            });

            input = $('#form_playback_type');

            input.data('select2').destroy();
            input.unbind('select2:select');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a market...",
                minimumResultsForSearch: 10
            });
        }

        if((step < 2) || (step === 'all')) {
            input = $('#form_book');

            input.data('select2').destroy();
            input.unbind('select2:select');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a data stream...",
                minimumResultsForSearch: 10
            });
        }

        if((step < 3) || (step === 'all')) {
            input = $('#form_dists');
            input.multiSelect('destroy');
            input.html('');
            input.multiSelect(searchableMultiSelectDef);
            input.closest('.form_dists_container').addClass('hidden');
            input.closest('.form_dists_container').parent().find('.help-text').removeClass('hidden');
        }
    };



    var ratingsCompOnMarketChange = function(select) {
        form_curr_market = form_markets[$(select).val()];
        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/allbooks/?dma=' + form_curr_market['dma'],
            dataType: 'json',
            success: function (data) {
                console.log("books");
                //console.log(data);
                console.log(collect(data).keyBy('playback_type').all());
                var form_playbacks = collect(data).sortBy('name').keyBy('playback_type').all();

                var input = $('#form_playback_type');
                input.attr('disabled', null);
                input.data('select2').destroy();
                input.unbind('select2:select');

                input.html('').append('<option value=""></option>');
                $.each(form_playbacks, function (index, value) {
                    input.append('<option value="' + index + '">' + playback_types_all[index] + '</option>')
                });
                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                });

                input.on('select2:select', function (evt) {
                    ratingsCompOnPlaybackChange(this);
                });
                ratingsCompMarketReset(1);
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
        /*form_playbacks = playback_types[form_curr_market['type']];

        var input = $('#form_playback_type');

        input.attr('disabled', null);
        input.data('select2').destroy();
        input.unbind('select2:select');

        input.html('').append('<option value=""></option>');
        $.each(form_playbacks, function (index, value) {
            input.append('<option value="' + index + '">' + value + '</option>')
        });

        input.select2({
            placeholder: "Select...",
            minimumResultsForSearch: 10
        });

        input.on('select2:select', function (evt) {
            ratingsCompOnPlaybackChange(this);
        });

        ratingsCompMarketReset(1);*/
    };

    var ratingsCompOnPlaybackChange = function(select) {
        form_curr_playback = $(select).val();

        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/allbooks/?dma=' + form_curr_market['dma'] + '&playback=' + form_curr_playback,
            dataType: 'json',
            success: function (data) {
                form_books = data;
                var input = $('#form_book');

                input.attr('disabled', null);
                input.data('select2').destroy();
                input.unbind('select2:select');

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                });

                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                });

                input.on('select2:select', function (evt) {
                    ratingsCompOnBookChange(this);
                });

                ratingsCompMarketReset(2);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };

    var ratingsCompOnBookChange = function(select) {
        form_curr_book = $(select).val();

        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/books/distributors/?books[]=' + form_curr_book,
            dataType: 'json',
            success: function (data) {
                form_dists = data;

                var input = $('#form_dists');

                input.multiSelect('destroy');
                input.html('');

                var html_broadcast = '';
                var html_cable = '';

                $.each(data, function (index, value) {
                    if (value['affil'] !== null) {
                        html_broadcast = html_broadcast + '<option value="' + value['id'] + '">'
                            + value['name'] + ' (' + value['affil'] + ')</option>';
                    } else {
                        html_cable = html_cable + '<option value="' + value['id'] + '">' + value['name'] + '</option>';
                    }
                });

                input.append('<optgroup label="Broadcast">' + html_broadcast + '</optgroup>');
                input.append('<optgroup label="Cable">' + html_cable + '</optgroup>');

                input.multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();

                        form_curr_dists = this.$element.val();
                        if(this.$element.val().length <= 20){
                            $('#form_submit').attr('disabled', null);
                        }else{
                            this.$element.multiSelect('deselect', values);
                            form_curr_dists = this.$element.val();
                            $('#form_submit').attr('disabled', 'disabled');
                                swal({
                                    title: "Warning",
                                    text: "The maximum number of stations is 20...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if(form_curr_dists.length < 20){
                            this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_dists.length + ' / 20)').removeClass('text-warning').addClass('text-muted');
                        }else{
                            this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_dists.length + ' / 20)').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();

                        form_curr_dists = this.$element.val();
                        if(form_curr_dists.length > 0){
                            $('#form_submit').attr('disabled', null);
                        }else{
                            $('#form_submit').attr('disabled', 'disabled');
                        }

                        this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_dists.length + ' / 20)').removeClass('text-warning').addClass('text-muted');
                    }
                });

                input.closest('.form_dists_container').removeClass('hidden');
                input.closest('.form_dists_container').parent().find('.help-text').addClass('hidden');

                ratingsCompMarketReset(3);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };



    var ratingsCompMarketSubmit = function(){
        $('#nielsen-disclaimer').find('.intab-disclaimer-individual').removeClass('hidden');


        book = $('#form_book').val();
        distributors = $('#form_dists').val();

        dp_start = moment($('#form_day_part_start').val(), 'h:mm A');
        dp_end = moment($('#form_day_part_end').val(), 'h:mm A');

        day_part = $('#form_day_part_days').val() + dp_start.format('HHmm') + dp_end.format('HHmm');

        show_loader();
        $.ajax({
            url: '/ratings/tv/local/books/composition/market?' + $.param({
                day_part: day_part,
                book: book,
                distributors: distributors
            }),
            success: function (data) {
                console.log("data");
                console.log(data);

                $.each(data['data'], function(index, value){
                    var change = {
                        "2-5": 'undefined',
                        "6-11": 'undefined',
                        "12-17": 'undefined',
                        "18-24": 'undefined',
                        "25-34": 'undefined',
                        "35-49": 'undefined',
                        "50-64": 'undefined',
                        "65+": 'undefined',
                    };
                    $.each(value, function(index, value) {
                        if (index === "12-14" || index === "15-17") {
                            if (change["12-17"] !== 'undefined') {
                                change["12-17"]['P']['impressions'] += value['P']['impressions'];
                                change["12-17"]['M']['impressions'] += value['M']['impressions'];
                                change["12-17"]['F']['impressions'] += value['F']['impressions'];
                            } else {
                                change["12-17"] = {
                                    'P': {'impressions': value['P']['impressions'], 'intab': value['P']['intab']},
                                    'F': {'impressions': value['M']['impressions'], 'intab': value['F']['intab']},
                                    'M': {'impressions': value['F']['impressions'], 'intab': value['M']['intab']}
                                };
                            }
                        } else if (index === "18-20" || index === "21-24") {
                            if (change["18-24"] !== 'undefined') {
                                change["18-24"]['P']['impressions'] += value['P']['impressions'];
                                change["18-24"]['M']['impressions'] += value['M']['impressions'];
                                change["18-24"]['F']['impressions'] += value['F']['impressions'];
                            } else {
                                change["18-24"] = {
                                    'P': {'impressions': value['P']['impressions'], 'intab': value['P']['intab']},
                                    'F': {'impressions': value['M']['impressions'], 'intab': value['F']['intab']},
                                    'M': {'impressions': value['F']['impressions'], 'intab': value['M']['intab']}
                                };
                            }
                        } else if (index === "50-54" || index === "55-64") {
                            if (change["50-64"] !== 'undefined') {
                                change["50-64"]['P']['impressions'] += value['P']['impressions'];
                                change["50-64"]['M']['impressions'] += value['M']['impressions'];
                                change["50-64"]['F']['impressions'] += value['F']['impressions'];
                            } else {
                                change["50-64"] = {
                                    'P': {'impressions': value['P']['impressions'], 'intab': value['P']['intab']},
                                    'F': {'impressions': value['M']['impressions'], 'intab': value['F']['intab']},
                                    'M': {'impressions': value['F']['impressions'], 'intab': value['M']['intab']}
                                };
                            }
                        } else {
                            change[index] = value;
                        }
                    });
                    data['data'][index] = change;
                });


                table_data = [];
                demo_data = [];

                $.each(data['data'], function(index, value){

                    p_base = value['2+']['P']['impressions'];
                    m_base = value['12+']['M']['impressions'];
                    f_base = value['12+']['F']['impressions'];

                    var push = {
                        'station': index,
                        'gender': 'P',
                        'base': p_base
                    };

                    var gender_data = {
                        'P': {},
                        'M': {
                            '2-5': {
                                'impressions': '',
                                'intab': true
                            },
                            '6-11': {
                                'impressions': '',
                                'intab': true
                            }
                        },
                        'F': {
                            '2-5': {
                                'impressions': '',
                                'intab': true
                            },
                            '6-11': {
                                'impressions': '',
                                'intab': true
                            }
                        }
                    };

                    $.each(value, function(index, value){
                        if($.inArray(index, ['2+', '12+']) === -1 && index !== 'queries'){
                            var curr_age = index;
                            $.each(value, function(index, value){
                                gender_data[index][curr_age] = value;
                            });
                        }
                    });

                    $.each(gender_data['P'], function(index, value){
                        push[index] = {
                            impressions: value['impressions'],
                            intab: value['intab'],
                        };
                    });

                    table_data.push(push);

                    push = {
                        'station': '',
                        'gender': 'M',
                        'base': m_base
                    };

                    $.each(gender_data['M'], function(index, value){
                        push[index] = {
                            impressions: value['impressions'],
                            intab: value['intab'],
                        };
                    });

                    table_data.push(push);

                    push = {
                        'station': '',
                        'gender': 'F',
                        'base': f_base
                    };

                    $.each(gender_data['F'], function(index, value){
                        push[index] = {
                            impressions: value['impressions'],
                            intab: value['intab'],
                        };
                    });

                    table_data.push(push);
                });

                $('#book').html(data['book']['market']['name'] + '; ' + data['book']['month'] + '/'
                    + data['book']['year'] + '; ' + data['book']['playback_type']);
                $('#day_part').html(ratingsHumanDaypart(day_part));

                var dt_options = {
                    columns: [
                        {
                            data: "station"
                        },{
                            data: "gender"
                        },{
                            data: "base"
                        },{
                            data: "2-5"
                        },{
                            data: "6-11"
                        },{
                            data: "12-17"
                        },{
                            data: "18-24"
                        },{
                            data: "25-34"
                        },{
                            data: "35-49"
                        },{
                            data: "50-64"
                        },{
                            data: "65+"
                        }
                    ],
                    "columnDefs": [
                        { "orderable": false, "targets": '_all' },
                        {
                            "render": function ( data, type, row, meta ) {
                                var curr_intab = false;
                                if(meta['col'] > 1){
                                    if(meta['col'] === 2){
                                        data = Math.ceil(data / 1000).toLocaleString("en-US", {
                                            minimumFractionDigits: 0
                                        });
                                    }else{
                                        if(data['impressions'] !== ''){
                                            /*if(data['impressions'] - Math.round(data['impressions']/1000)*1000 > 400){
                                                data['impressions'] += 200;
                                            }*/
                                            var html = '<div class="left">' + Number(Math.round((data['impressions'] / 1000) +'e0')+'e-0').toLocaleString("en-US", {
                                                minimumFractionDigits: 0
                                            });
                                            if(! data['intab']){
                                                curr_intab = true;
                                                html += '<span class="intab-indicator">&nbsp;✝</span>'
                                            }
                                            if(Math.ceil(row['base']) >= 35000){
                                                console.log(Math.round(data['impressions']/1000));
                                                console.log(Math.ceil(row['base']/1000));
                                            }
                                            html += '</div><div class="right"><span style="font-weight: 400;">(' + Number(Math.round(((Math.round(data['impressions']/1000) / Math.ceil(row['base']/1000)) * 100) +'e1')+'e-1').toString() + '%)</span></div>';

                                            data = html;
                                        }else{
                                            data = '';
                                        }
                                    }

                                }

                                if(! curr_intab){
                                    var disclaimer = $('#nielsen-disclaimer');
                                    if(disclaimer.find('.intab-disclaimer-individual').hasClass('hidden')){
                                        disclaimer.find('.intab-disclaimer-individual').removeClass('hidden');
                                    }
                                }

                                return data;

                            },
                            "targets": '_all'
                        },
                        { "width": "7.5%", "targets": 'demo' }
                    ],
                    "order": [],
                    dom: 'Bfrtip',
                    buttons: [
                        'copy',
                        {
                            extend: 'excel',
                            messageTop: $('#book').html() +' > ' + $('#day_part').html(),
                        },
                        {
                            extend: 'csv',
                            messageTop:  $('#book').html() +' >  ' + $('#day_part').html(),
                        },
                        {
                            extend: 'print',
                            messageTop:  $('#book').html() +' > ' + $('#day_part').html(),
                        },
                    ],
                    "searching": false,
                    "paging": false,
                    "info": false,
                    data: table_data
                };

                if(typeof dt !== 'undefined'){
                    dt.destroy();
                    $('#ratings_market_comp_table').find('tbody').empty();
                }

                dt = $('#ratings_market_comp_table').DataTable( dt_options );

                if($('.ratings-table-container').hasClass('hidden')){
                    $('.ratings-table-container').removeClass('hidden');
                }

                $('#tv_comp_market_generate_panel').find('div.clickable').click();


                hide_loader();
            }
        });
    };
}